import { withTranslation, WithTranslation } from "react-i18next"
import Card from "@/components/card"
import Space from "@/components/space"
import Link from "@/components/link"

type Props = WithTranslation

function HomeResourcesWidget({ t }: Props) {
  return (
    <Card
      onClick={() => window.open("https://www.id-tree.com/aide", "_blank")}
      className="cursor-pointer w-56 flex flex-col justify-center"
      >

      <div className="flex justify-center">
        <Space />
        <img
          src={require("@/assets/nicolas-naudin.png")}
          alt={t("utils_help_cs_btn")}
          className="_hover w-24 h-24 mb-4 object-cover rounded-full"
          loading="lazy"
        />
        <Space />
      </div>

      <div className="height-10" />

      <div className="flex justify-center w-full">
        <Space />
        <Link isWithoutMargin={true} onClick={() => window.open("https://www.id-tree.com/aide", "_blank")}>
          <div className="flex justify-center _hover text-center w-48">{t("utils_help_cs_btn")}</div>
        </Link>
        <Space />
        {/* <p className="_hover text-center"><b>{t("utils_help_cs_btn")}</b></p> */}
      </div>
    </Card>
  )
}

export default withTranslation()(HomeResourcesWidget)
